<template lang="pug">
  
  div
    MHeader(
      page-title="Advertiser Management"
      v-bind:breadcrumbs="breadcrumbs"
    )
    div( v-if="loading || $apollo.loading" ) Loading, please wait...
    div( v-else class="wrapper wrapper-content" )
      div( class="ibox mt-3" )
        div( class="ibox-content" )
          div( class="row mb-4" )
            div( class="col-12" )
              strong Upload CSV of Advertisers:&nbsp;
              router-link( to="/documentation" ) (CSV format + instructions)

          div( class="row" v-if="fileUploadError !== ''" )
            div( class="col-12" )
              span( style="color:red;" ) {{ fileUploadError }}
          
          div( class="row" )
            div( class="col-6" )
              input( id="csv" class="custom-file-input" type="file" v-on:change="updateCsvFile($event)" )
              label( for="csv" class="custom-file-label ml-3" ) {{ ! csv ? 'Upload an advertiser CSV' : csv.name }}

            div( class="col-4" )
              select( class="form-control" v-model="networkName" )
                option( v-for="n in networks" v-bind:value="n.name" ) {{ n.name }}
            
            div( class="col-2 text-right" )
              button( class="btn btn-primary" v-bind:disabled="! csv && networkName === null && ! isUploading" v-on:click="uploadCsv" )
                span( v-if="isUploading" )
                  MLoadingSpinner( class="mr-2" )
                  | Uploading...
                span( v-else ) Upload
          
          div( class="row mt-4" v-if="postUploadErrors && postUploadErrors.length > 0" )
            div( class="col-12" )
              p
                strong( class="text-danger" ) Some rows were not uploaded. See below for errors:
              table( class="table table-hover" )
                thead
                  tr
                    th Row #
                    th Advertiser Name
                    th Prog ID
                    th Error Message
                tbody
                  tr( v-for="error in postUploadErrors" )
                    td {{ error.row }}
                    td {{ error.advertiserName }}
                    td {{ error.progId }}
                    td {{ error.errorMessage }}

</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  
  data() {
    return {
      breadcrumbs: [
        { label: 'Home', link: '/' },
        { label: 'Advertisers Management', link: '/cms/advertisers' }
      ],
      loading: true,
      filterString: '',
      networks: [],
      fileUploadError: '',
      csv: null,
      networkName: null,
      isUploading: false,
      postUploadErrors: [],
    }
  },

  apollo: {
  },

  computed: {
  },

  methods: {

    updateCsvFile(e) {
      const file = e.target.files[0]

      if (! file.name.endsWith('.csv')) {
        this.fileUploadError = 'Only .CSV files are supported'
        return
      }

      this.fileUploadError = ''
      this.csv = file
    },

    async uploadCsv() {
      this.isUploading = true
      const formData = new FormData()
      formData.append('csv', this.csv)
      this.postUploadErrors = await this.$moonpull.uploadAdvertisers(this.networkName, formData)
      this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully uploaded advertisers. Please refresh the page.` })
      this.isUploading = false
    },

    getNetwork(id) {
      return this.networks.find(n => n.id === id)
    }

  },

  async beforeCreate() {
    this.networks = (await this.$moonpull.getNetworks()).filter(n => ! n.aliasNetworkId)
    this.loading = false
  }

})
</script>